import { useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Car, Inbox, ClipboardList, BookmarkCheck, FileText, Receipt, ShoppingBag, Handshake, BadgePoundSterling, ShieldAlert, Settings, LogOut, Menu, X, ExternalLink } from "lucide-react";
import { Monogram } from "@/components/site/Logo";
import { useAuth } from "./auth";

const LINKS = [
  ["/admin", "Dashboard", LayoutDashboard], ["/admin/vehicles", "Vehicles", Car], ["/admin/enquiries", "Enquiries", Inbox],
  ["/admin/valuations", "Valuations", ClipboardList], ["/admin/reservations", "Reservations", BookmarkCheck], ["/admin/invoices", "Invoices", Receipt], ["/admin/purchases", "Purchases", ShoppingBag], ["/admin/sales", "Sales", BadgePoundSterling], ["/admin/sor", "Sale or Return", Handshake], ["/admin/claims", "Claims", ShieldAlert],
  ["/admin/content", "Site Content", FileText], ["/admin/settings", "Settings", Settings],
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = (
    <nav className="flex flex-col gap-1">
      {LINKS.map(([to, label, Icon]) => (
        <NavLink key={to} to={to} end={to === "/admin"} onClick={() => setOpen(false)} data-testid={`admin-nav-${label.toLowerCase().replace(/\s/g, "-")}`}
          className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-paper/10 text-paper" : "text-stone hover:text-paper"}`}>
          <Icon className="h-4 w-4" strokeWidth={1.5} />{label}
        </NavLink>
      ))}
    </nav>
  );
  return (
    <div className="min-h-screen bg-[#F2EEE5] lg:flex" data-testid="admin-layout">
      <aside className={`on-dark fixed inset-y-0 left-0 z-50 w-64 flex-col bg-forest p-5 text-paper lg:sticky lg:top-0 lg:flex lg:h-screen ${open ? "flex" : "hidden"}`}>
        <div className="flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-3"><Monogram className="h-9 w-9" light /><span className="font-serif text-xl">Admin</span></Link>
          <button className="lg:hidden" onClick={() => setOpen(false)} aria-label="Close menu"><X className="h-5 w-5" /></button>
        </div>
        <div className="mt-10 flex-1">{nav}</div>
        <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-3 py-2 text-sm text-stone hover:text-paper"><ExternalLink className="h-4 w-4" />View website</a>
        <div className="mt-4 border-t border-paper/15 pt-4 text-xs text-stone">
          <p className="truncate">{user?.email}</p>
          <button onClick={logout} className="mt-3 flex items-center gap-2 text-sm text-paper" data-testid="admin-logout"><LogOut className="h-4 w-4" />Sign out</button>
        </div>
      </aside>
      <div className="min-w-0 flex-1">
        <div className="flex items-center justify-between border-b border-stone bg-paper px-5 py-3 lg:hidden">
          <button onClick={() => setOpen(true)} aria-label="Open admin menu" data-testid="admin-menu-open"><Menu className="h-6 w-6" /></button>
          <span className="font-serif text-xl">Cirencester 4x4 Admin</span><span />
        </div>
        <div className="mx-auto max-w-[1300px] p-5 sm:p-8 lg:p-10"><Outlet /></div>
      </div>
    </div>
  );
}

export const AdminTitle = ({ title, children }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
    <h1 className="font-serif text-4xl text-charcoal">{title}</h1>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);
